import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  StyledInput,
  type StyledInputProps,
} from '~/components/elements/StyledInput'
import { useFormField } from '~/hooks/useFormField'
import { defaultDocumentReportTitleI18nKey } from '~/utils'

import { type InputValues } from '../utils'

export const DocumentReportEditTitleInput = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const titleField = useFormField(control, 'title')

  const defaultTitle = t(defaultDocumentReportTitleI18nKey)

  const handleBlur = React.useCallback<EH<StyledInputProps, 'onBlur'>>(() => {
    titleField.onBlur()
    if (titleField.value.length === 0) {
      titleField.onChange(defaultTitle)
    }
  }, [titleField, defaultTitle])

  const handleFocus = React.useCallback<EH<StyledInputProps, 'onFocus'>>(
    (event) => {
      if (titleField.value === defaultTitle) {
        event.currentTarget.select()
      }
    },
    [titleField, defaultTitle],
  )

  return (
    <StyledInput
      placeholder={t('document_title')}
      width="100%"
      {...titleField}
      onBlur={handleBlur}
      onFocus={handleFocus}
    />
  )
}
